function initBundleToggles() {
  document.querySelectorAll('[data-toggle="bundle"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const bundleId = btn.getAttribute('data-bundle-id');
      const itemsContainer = document.querySelector(`.bundle-items[data-bundle-id="${bundleId}"]`);
      const textEl = btn.querySelector('.bundle-toggle-text');
      const arrowEl = btn.querySelector('.bundle-toggle-arrow');

      if (!itemsContainer || !textEl || !arrowEl) return;

      const isHidden = window.getComputedStyle(itemsContainer).display === 'none';
      itemsContainer.style.display = isHidden ? 'block' : 'none';

      const itemCount = textEl.textContent.match(/\d+/)[0] || '';
      if (isHidden) {
        textEl.textContent = `Verberg ${itemCount} artikelen`;
        arrowEl.innerHTML =
          '<svg viewBox="0 0 20 20" height="2rem"><path fill-rule="evenodd" d="M14.53 12.28a.75.75 0 0 1-1.06 0l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06Z"></path></svg>';
      } else {
        textEl.textContent = `Weergeven ${itemCount} artikelen`;
        arrowEl.innerHTML =
          '<svg viewBox="0 0 20 20" height="2rem"><path fill-rule="evenodd" d="M5.72 8.47a.75.75 0 0 1 1.06 0l3.47 3.47 3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z"></path></svg>';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initBundleToggles);
document.addEventListener('cart:change', () => setTimeout(initBundleToggles, 50));
document.addEventListener('shopify:section:load', initBundleToggles);

if (!window.customElements.get('mobile-atc-sticky')) {
  class MobileAtcSticky extends HTMLElement {
    static STATES = {
      FIXED: 'fixed',
      DOCKED: 'docked',
      FIXED_AFTER: 'fixed-after',
      HIDDEN: 'hidden',
      TRANSITION: 'transition',
    };
    static CONFIG = { MARGIN: 16, HEIGHT: 42, HYSTERESIS: 15, TRANSITION_DIST: 150 };

    constructor() {
      super();
      this.state = null;
      this.mq = window.matchMedia('(max-width: 699px)');
      this.hasDragPanel = false;
    }

    connectedCallback() {
      if (!this.mq.matches) return;
      this.container = this.querySelector('[data-atc-container]');
      this.btn = this.container?.querySelector('buy-buttons');
      this.footer = document.querySelector('.shopify-section--footer, .footer, footer');
      if (!this.container || !this.btn) return;

      // Check if drag panel is enabled
      this.hasDragPanel = !!document.querySelector('.mobile-drag-panel');
      this.dragPanelExpanded = false;

      this.btn.style.transition = 'opacity 0.2s ease';
      this.onScroll = () => this.update();
      this.onMq = (e) => (e.matches ? this.initState() : this.reset());

      // Listen for drag panel events
      this.onDragPanelExpand = () => {
        this.dragPanelExpanded = true;
        // Use DOCKED so button stays visible inside panel (not fixed/sticky)
        this.apply(MobileAtcSticky.STATES.DOCKED);
      };
      this.onDragPanelCollapse = () => {
        this.dragPanelExpanded = false;
        // Immediately show as sticky (no animation)
        this.apply(MobileAtcSticky.STATES.FIXED_AFTER);
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('dragpanel:expand', this.onDragPanelExpand);
      window.addEventListener('dragpanel:collapse', this.onDragPanelCollapse);
      this.mq.addEventListener('change', this.onMq);
      this.initState();
    }

    initState() {
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('dragpanel:expand', this.onDragPanelExpand);
      window.removeEventListener('dragpanel:collapse', this.onDragPanelCollapse);
      this.mq.removeEventListener('change', this.onMq);
    }

    reset() {
      this.container.removeAttribute('data-docked');
      this.container.removeAttribute('data-hidden');
      Object.assign(this.btn.style, {
        position: '',
        left: '',
        right: '',
        bottom: '',
        width: '',
        opacity: '',
        visibility: '',
        pointerEvents: '',
      });
      this.state = null;
    }

    update() {
      if (!this.mq.matches) return;

      const { FIXED, DOCKED, FIXED_AFTER, HIDDEN, TRANSITION } = MobileAtcSticky.STATES;
      const { MARGIN, HYSTERESIS, TRANSITION_DIST } = MobileAtcSticky.CONFIG;

      const rect = this.container.getBoundingClientRect();
      const vh = window.innerHeight;
      const footerRect = this.footer?.getBoundingClientRect();
      // Hide button when footer is within 100px of viewport bottom (before overlap)
      const nearFooter = footerRect && footerRect.top < vh + 100;
      const dist = rect.bottom - (vh - MARGIN);
      const above = rect.bottom < 0;

      let next = this.state;

      // Same behavior for both drag panel and normal mode
      if (nearFooter) next = HIDDEN;
      else if (above) next = FIXED_AFTER;
      else if (this.state === DOCKED && dist > HYSTERESIS) next = TRANSITION;
      else if (this.state === FIXED_AFTER && !above && dist <= 0) next = DOCKED;
      else if (dist <= 0) next = DOCKED;
      else if (dist <= TRANSITION_DIST) next = TRANSITION;
      else next = FIXED;

      if (next === TRANSITION) this.transition(dist);
      else if (next !== this.state) this.apply(next);
    }

    transition(dist) {
      const { TRANSITION_DIST } = MobileAtcSticky.CONFIG;
      const progress = 1 - Math.max(0, Math.min(1, dist / TRANSITION_DIST));
      const inset = 40 - 20 * progress;

      this.state = MobileAtcSticky.STATES.TRANSITION;
      this.container.removeAttribute('data-docked');
      this.container.removeAttribute('data-hidden');
      Object.assign(this.btn.style, {
        position: 'fixed',
        bottom: '16px',
        left: `${inset}px`,
        right: `${inset}px`,
        width: 'auto',
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
      });
    }

    apply(s) {
      const { FIXED, DOCKED, FIXED_AFTER, HIDDEN } = MobileAtcSticky.STATES;
      this.state = s;
      this.container.removeAttribute('data-docked');
      this.container.removeAttribute('data-hidden');

      const styles = {
        [FIXED]: {
          position: 'fixed',
          bottom: '16px',
          left: '40px',
          right: '40px',
          width: 'auto',
          opacity: '1',
          visibility: 'visible',
          pointerEvents: 'auto',
        },
        [DOCKED]: {
          transition: 'none',
          position: 'relative',
          bottom: 'auto',
          left: '0',
          right: '0',
          width: '100%',
          opacity: '1',
          visibility: 'visible',
          pointerEvents: 'auto',
        },
        [FIXED_AFTER]: {
          position: 'fixed',
          bottom: '16px',
          left: '20px',
          right: '20px',
          width: 'auto',
          opacity: '1',
          visibility: 'visible',
          pointerEvents: 'auto',
        },
        [HIDDEN]: {
          position: 'fixed',
          bottom: '16px',
          left: '20px',
          right: '20px',
          width: 'auto',
          opacity: '0',
          visibility: 'hidden',
          pointerEvents: 'none',
        },
      };

      if (s === DOCKED) this.container.setAttribute('data-docked', '');
      if (s === HIDDEN) {
        this.container.setAttribute('data-hidden', '');
        this.btn.setAttribute('data-hidden', '');
      } else {
        this.btn.removeAttribute('data-hidden');
      }
      Object.assign(this.btn.style, styles[s]);
    }
  }

  customElements.define('mobile-atc-sticky', MobileAtcSticky);
}

(function () {
  function initDragPanel() {
    const panel = document.querySelector('.mobile-drag-panel');
    if (!panel) return;

    const handle = panel.querySelector('.mobile-drag-panel__handle');
    if (!handle) return;

    const mq = window.matchMedia('(max-width: 699px)');

    // State
    let isExpanded = false;
    let isDraggingHandle = false;
    let dragConfirmed = false;
    let startY = 0;
    let startMargin = 0;
    let maxSlideAmount = 0;
    let lastTouchTime = 0;

    // Constants
    const DRAG_CONFIRM_THRESHOLD = 10;
    const SNAP_THRESHOLD = 40;
    const SCROLL_COLLAPSE_THRESHOLD = 50;

    function getHeaderHeight() {
      const header = document.querySelector('.shopify-section--header');
      const announcementBar = document.querySelector('.shopify-section--announcement-bar');
      let height = 0;
      if (header) height += header.getBoundingClientRect().height;
      if (announcementBar) height += announcementBar.getBoundingClientRect().height;
      return height;
    }

    function getNaturalPanelTop() {
      const currentMargin = parseInt(window.getComputedStyle(panel).marginTop) || 0;
      return panel.getBoundingClientRect().top - currentMargin;
    }

    function isHandleInView() {
      const rect = handle.getBoundingClientRect();
      return rect.top >= 0 && rect.top <= window.innerHeight;
    }

    function expand() {
      const slideAmount = getNaturalPanelTop() - getHeaderHeight();

      isExpanded = true;
      panel.setAttribute('data-expanded', 'true');
      panel.style.transition = 'margin-top 0.3s ease';
      panel.style.marginTop = -slideAmount - 1 + 'px';

      window.dispatchEvent(new CustomEvent('dragpanel:expand'));
    }

    function collapse(shouldScroll = true) {
      isExpanded = false;
      panel.setAttribute('data-expanded', 'false');
      panel.style.transition = 'margin-top 0.3s ease';
      panel.style.marginTop = '0px';

      // Only scroll to top if requested and not during active touch
      if (shouldScroll && !isDraggingHandle) {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 50);
      }

      window.dispatchEvent(new CustomEvent('dragpanel:collapse'));
    }

    // === HANDLE TOUCH EVENTS ===
    handle.addEventListener(
      'touchstart',
      function (e) {
        isDraggingHandle = true;
        dragConfirmed = false;
        startY = e.touches[0].clientY;
        startMargin = parseInt(window.getComputedStyle(panel).marginTop) || 0;
        maxSlideAmount = getNaturalPanelTop() - getHeaderHeight();
      },
      { passive: true }
    );

    handle.addEventListener(
      'touchmove',
      function (e) {
        if (!isDraggingHandle) return;

        const currentY = e.touches[0].clientY;
        const deltaY = currentY - startY;

        // Confirm drag after threshold
        if (!dragConfirmed) {
          if (Math.abs(deltaY) > DRAG_CONFIRM_THRESHOLD) {
            dragConfirmed = true;
            panel.style.transition = 'none';
          } else {
            return;
          }
        }

        e.preventDefault();

        // Calculate and clamp new margin
        const newMargin = Math.max(-maxSlideAmount, Math.min(0, startMargin + deltaY));
        panel.style.marginTop = newMargin + 'px';
      },
      { passive: false }
    );

    handle.addEventListener(
      'touchend',
      function (e) {
        if (!isDraggingHandle) return;

        const wasDragging = dragConfirmed;
        const currentY = e.changedTouches[0].clientY;
        const deltaY = currentY - startY;

        isDraggingHandle = false;
        dragConfirmed = false;
        lastTouchTime = Date.now();

        if (!wasDragging) {
          // It was a tap, toggle the panel
          isExpanded ? collapse() : expand();
          return;
        }

        // Snap based on drag direction and threshold
        if (isExpanded) {
          deltaY >= SNAP_THRESHOLD ? collapse() : expand();
        } else {
          deltaY <= -SNAP_THRESHOLD ? expand() : collapse(false);
        }
      },
      { passive: true }
    );

    handle.addEventListener(
      'touchcancel',
      function () {
        isDraggingHandle = false;
        dragConfirmed = false;
        // Return to previous state
        isExpanded ? expand() : collapse(false);
      },
      { passive: true }
    );

    // === CLICK (desktop + tap fallback) ===
    handle.addEventListener('click', function () {
      // Ignore click if it's right after a touch (prevents double-fire)
      if (Date.now() - lastTouchTime < 300) return;
      isExpanded ? collapse() : expand();
    });

    // === SCROLL TO COLLAPSE (when handle visible) ===
    let lastScrollY = window.scrollY;
    let scrollAccumulator = 0;

    window.addEventListener(
      'scroll',
      function () {
        if (!mq.matches || !isExpanded || isDraggingHandle) return;

        const currentScrollY = window.scrollY;
        const scrollDelta = lastScrollY - currentScrollY; // positive = scrolling up

        if (scrollDelta > 0 && isHandleInView()) {
          scrollAccumulator += scrollDelta;
          if (scrollAccumulator >= SCROLL_COLLAPSE_THRESHOLD) {
            collapse();
            scrollAccumulator = 0;
          }
        } else {
          scrollAccumulator = 0;
        }

        lastScrollY = currentScrollY;
      },
      { passive: true }
    );

    // === DESKTOP WHEEL ===
    window.addEventListener(
      'wheel',
      function (e) {
        if (!mq.matches || !isExpanded) return;
        if (e.deltaY < 0 && isHandleInView()) {
          collapse();
        }
      },
      { passive: true }
    );

    // === MEDIA QUERY CHANGE ===
    mq.addEventListener('change', function (e) {
      if (!e.matches && isExpanded) {
        collapse(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDragPanel);
  } else {
    initDragPanel();
  }
})();

(function () {
  function initImageFadeIn() {
    const galleryImages = document.querySelectorAll('.product-gallery--clickable .product-gallery__media img');

    galleryImages.forEach((img) => {
      if (img.complete && img.naturalHeight !== 0) {
        img.setAttribute('data-loaded', 'true');
      } else {
        img.addEventListener('load', function () {
          img.setAttribute('data-loaded', 'true');
        });
        img.addEventListener('error', function () {
          img.setAttribute('data-loaded', 'true');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageFadeIn);
  } else {
    initImageFadeIn();
  }

  document.addEventListener('shopify:section:load', initImageFadeIn);
})();

// Smooth infinite scroll for mobile pdp
(function () {
  const mobileMq = window.matchMedia('screen and (max-width: 999px)');
  const LOOP_ATTR = 'data-loop-clone';
  const loopState = new WeakMap();

  function getRealCells(carousel) {
    return Array.from(
      carousel.querySelectorAll(`.product-gallery__media:not([hidden]):not([${LOOP_ATTR}])`)
    );
  }

  function removeClones(carousel) {
    carousel.querySelectorAll(`[${LOOP_ATTR}]`).forEach((node) => node.remove());
    carousel.removeAttribute('data-loop-ready');
  }

  function wrapFilter(carousel) {
    if (loopState.has(carousel)) return;
    const originalFilter = carousel.filter ? carousel.filter.bind(carousel) : null;
    if (!originalFilter) return;
    loopState.set(carousel, { originalFilter });
    carousel.filter = (indexes = []) => {
      if (carousel.dataset.loopReady !== 'true') {
        originalFilter(indexes);
        return;
      }
      const shifted = indexes.map((index) => index + 1);
      originalFilter(shifted);

      const cells = carousel.querySelectorAll('.product-gallery__media');
      const firstRealHidden = cells[1]?.hasAttribute('hidden');
      const lastRealHidden = cells[cells.length - 2]?.hasAttribute('hidden');
      if (cells[0]) cells[0].toggleAttribute('hidden', !!lastRealHidden);
      if (cells[cells.length - 1]) cells[cells.length - 1].toggleAttribute('hidden', !!firstRealHidden);
    };
  }

  function restoreFilter(carousel) {
    const state = loopState.get(carousel);
    if (!state || !state.originalFilter) return;
    carousel.filter = state.originalFilter;
    loopState.delete(carousel);
  }

  function setupLoop(carousel) {
    if (!carousel || !mobileMq.matches) return;
    removeClones(carousel);
    const realCells = getRealCells(carousel);
    if (realCells.length <= 1) return;

    wrapFilter(carousel);
    const firstClone = realCells[0].cloneNode(true);
    const lastClone = realCells[realCells.length - 1].cloneNode(true);

    firstClone.removeAttribute('id');
    lastClone.removeAttribute('id');
    firstClone.classList.remove('is-initial');
    lastClone.classList.remove('is-initial');
    firstClone.setAttribute(LOOP_ATTR, 'first');
    lastClone.setAttribute(LOOP_ATTR, 'last');

    // Clones are never the real first slide, even if they're a clone of it (cloneNode copies
    // loading/fetchpriority verbatim) — force them back to the same lazy/auto state every other
    // non-first slide has.
    [firstClone, lastClone].forEach((clone) => {
      const img = clone.querySelector('img');
      if (img) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('fetchpriority', 'auto');
      }
    });

    carousel.insertBefore(lastClone, carousel.firstChild);
    carousel.appendChild(firstClone);
    carousel.dataset.loopReady = 'true';

    if (typeof carousel.select === 'function') {
      carousel.select(1, { instant: true });
    }
  }

  function bindLoopingCarousel(carousel) {
    if (!carousel || carousel.dataset.loopSwipeBound === 'true') return;

    carousel.addEventListener(
      'carousel:change',
      (event) => {
        if (!mobileMq.matches) return;
        const cell = event.detail && event.detail.cell;
        if (cell && cell.hasAttribute(LOOP_ATTR)) {
          event.stopImmediatePropagation();
        }
      },
      { capture: true }
    );

    carousel.addEventListener('carousel:settle', (event) => {
      if (!mobileMq.matches || carousel.dataset.loopReady !== 'true') return;
      const cell = event.detail && event.detail.cell;
      if (!cell || !cell.hasAttribute(LOOP_ATTR)) return;

      const cells = carousel.querySelectorAll('.product-gallery__media:not([hidden])');
      if (cells.length <= 2) return;

      const targetIndex = cell.getAttribute(LOOP_ATTR) === 'last' ? cells.length - 2 : 1;
      requestAnimationFrame(() => {
        carousel.select(targetIndex, { instant: true });
      });
    });

    carousel.addEventListener('carousel:filter', () => {
      if (!mobileMq.matches) return;
      setupLoop(carousel);
    });

    carousel.dataset.loopSwipeBound = 'true';
    setupLoop(carousel);
  }

  function teardownLoop(carousel) {
    if (!carousel) return;
    removeClones(carousel);
    restoreFilter(carousel);
  }

  function initLoopingGallerySwipe() {
    if (!document.body.classList.contains('template--product')) return;
    document.querySelectorAll('product-gallery .product-gallery__carousel').forEach((carousel) => {
      if (mobileMq.matches) {
        bindLoopingCarousel(carousel);
      } else {
        teardownLoop(carousel);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoopingGallerySwipe);
  } else {
    initLoopingGallerySwipe();
  }

  document.addEventListener('shopify:section:load', initLoopingGallerySwipe);
  mobileMq.addEventListener('change', initLoopingGallerySwipe);
})();

// Keep loading/fetchpriority correct on the PDP gallery no matter what else touches it.
// ScrollCarousel (theme.js) removes the `loading` attribute from the previous/current/next
// slide on every swipe, which can leave a non-first image without loading="lazy". This
// restores it immediately, for every image except the one legitimate first (non-clone) slide.
(function () {
  if (!('MutationObserver' in window)) return;

  function enforce(carousel) {
    const firstImg = carousel.querySelector('.product-gallery__media:not([data-loop-clone]) img');
    carousel.querySelectorAll('.product-gallery__media img').forEach((img) => {
      if (img === firstImg) return;
      if (img.getAttribute('loading') !== 'lazy') img.setAttribute('loading', 'lazy');
    });
  }

  function watch(carousel) {
    if (!carousel || carousel.dataset.loadingGuardBound === 'true') return;
    carousel.dataset.loadingGuardBound = 'true';
    enforce(carousel);
    new MutationObserver(() => enforce(carousel)).observe(carousel, {
      attributes: true,
      attributeFilter: ['loading'],
      subtree: true
    });
  }

  function init() {
    document.querySelectorAll('product-gallery .product-gallery__carousel').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

(function () {
  const STORAGE_KEY = 'endu:pdp-size-selection';
  const MAX_AGE_MS = 5 * 60 * 1000;
  const STABLE_APPLY_MS = 800;

  function getMainProductPicker() {
    return (
      document.querySelector('variant-picker[context="main_product"]') ||
      document.querySelector('variant-picker[form-id^="product-form-main-"]') ||
      document.querySelector('.shopify-section--main-product variant-picker')
    );
  }

  function getMainSelectionsFromPicker(picker) {
    if (!picker) return [];

    return Array.from(picker.querySelectorAll('input[data-option-position]:checked'))
      .map((input) => ({
        position: input.getAttribute('data-option-position'),
        label:
          input.getAttribute('data-option-label') ||
          input.labels?.[0]?.textContent?.trim() ||
          input.value ||
          ''
      }))
      .filter((selection) => selection.position && selection.label);
  }

  function normalizeOptionText(text) {
    return (text || '').trim().toLowerCase();
  }

  function saveCurrentMainSelections() {
    const picker = getMainProductPicker();
    const mainSelections = getMainSelectionsFromPicker(picker);
    if (mainSelections.length === 0) return;

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          timestamp: Date.now(),
          path: window.location.pathname,
          mainSelections
        })
      );
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function findInputForSelection(picker, selection) {
    const safeLabel = CSS.escape(selection.label);
    const exactSelector = `input[data-option-position="${selection.position}"][data-option-label="${safeLabel}"]`;
    const exactInput = picker.querySelector(exactSelector);
    if (exactInput) return exactInput;

    const candidates = Array.from(
      picker.querySelectorAll(`input[data-option-position="${selection.position}"]`)
    );
    const normalizedLabel = normalizeOptionText(selection.label);

    return (
      candidates.find((input) => {
        const label =
          input.getAttribute('data-option-label') ||
          input.labels?.[0]?.textContent?.trim() ||
          input.value ||
          '';
        return normalizeOptionText(label) === normalizedLabel;
      }) || null
    );
  }

  function applySelectionToPicker(picker, selection) {
    const targetInput = findInputForSelection(picker, selection);
    if (!targetInput || targetInput.checked || targetInput.disabled) return false;

    targetInput.checked = true;
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));
    targetInput.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  }

  function isSelectionApplied(picker, selection) {
    const targetInput = findInputForSelection(picker, selection);
    return !!(targetInput && targetInput.checked);
  }

  function getApplicableSelections(picker, selections) {
    return selections.filter((selection) => {
      const positionSelector = `input[data-option-position="${selection.position}"]`;
      if (!picker.querySelector(positionSelector)) return false;

      return !!findInputForSelection(picker, selection);
    });
  }

  function usesMobileAtcSelection() {
    return window.matchMedia('(max-width: 749px)').matches && !!document.querySelector(
      'mobile-atc-experiment[data-mode="v1"], mobile-atc-experiment[data-mode="v2"]'
    );
  }

  function restoreMainSelections() {
    if (!document.body.classList.contains('template--product') || usesMobileAtcSelection()) return;

    let payload = null;
    try {
      payload = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      payload = null;
    }

    const mainSelections = Array.isArray(payload?.mainSelections) ? payload.mainSelections : [];
    if (mainSelections.length === 0) return;

    const timestamp = typeof payload.timestamp === 'number' ? payload.timestamp : 0;
    if (!timestamp || Date.now() - timestamp > MAX_AGE_MS) return;

    const startedAt = Date.now();
    const timeoutMs = 15000;
    let done = false;
    let stableSince = null;

    const stopOnUserInteraction = () => finish(true);

    const finish = (success) => {
      if (done) return;
      done = true;
      observer.disconnect();
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      document.removeEventListener('change', stopOnUserInteraction, true);
    };

    const tryApply = () => {
      if (done) return;
      if (usesMobileAtcSelection()) {
        finish(true);
        return;
      }
      const picker = getMainProductPicker();
      if (!picker) {
        if (Date.now() - startedAt >= timeoutMs) finish(false);
        return;
      }

      const pickerOptionsCount = picker.querySelectorAll('input[data-option-position]').length;
      if (pickerOptionsCount === 0) {
        if (Date.now() - startedAt >= timeoutMs) finish(false);
        return;
      }

      const applicableSelections = getApplicableSelections(picker, mainSelections);
      if (applicableSelections.length === 0) {
        finish(true);
        return;
      }

      applicableSelections.forEach((selection) => applySelectionToPicker(picker, selection));
      const fullyApplied = applicableSelections.every((selection) => isSelectionApplied(picker, selection));
      if (fullyApplied) {
        if (stableSince === null) stableSince = Date.now();
        if (Date.now() - stableSince >= STABLE_APPLY_MS) finish(true);
        return;
      }

      stableSince = null;

      if (Date.now() - startedAt >= timeoutMs) finish(false);
    };

    const observer = new MutationObserver(tryApply);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', stopOnUserInteraction, true);

    const intervalId = window.setInterval(tryApply, 300);
    const timeoutId = window.setTimeout(() => finish(false), timeoutMs + 1000);
    tryApply();
  }

  function switchToProduct(productUrl, sectionId) {
    const sectionEl = document.getElementById('shopify-section-' + sectionId);
    if (!sectionEl) return;
    const separator = productUrl.includes('?') ? '&' : '?';
    fetch(productUrl + separator + 'section_id=' + sectionId)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newSection = tmp.querySelector('#shopify-section-' + sectionId) || tmp.firstElementChild;
        if (newSection) {
          sectionEl.replaceWith(newSection);
          newSection.querySelectorAll('script').forEach(function(oldScript) {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach(function(attr) {
              newScript.setAttribute(attr.name, attr.value);
            });
            newScript.textContent = oldScript.textContent;
            document.head.appendChild(newScript);
            newScript.remove();
          });
          newSection.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } }));
          if (window.Trustpilot) {
            newSection.querySelectorAll('.trustpilot-widget').forEach(function(el) {
              window.Trustpilot.loadFromElement(el, true);
            });
          }
        }
        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
        window.history.pushState({}, '', productUrl);
      });
  }

  document.addEventListener('change', function(event) {
    const input = event.target;
    if (!input.matches('input[data-option-position][data-product-url]')) return;
    const productUrl = input.dataset.productUrl;
    if (!productUrl) return;
    const variantPicker = document.querySelector('variant-picker[context="main_product"]');
    if (!variantPicker) return;
    switchToProduct(productUrl, variantPicker.getAttribute('section-id'));
  }, true);

  document.addEventListener('click', function(event) {
    const link = event.target.closest('color-option-redirect a[href*="/products/"]');
    if (!link) return;
    event.preventDefault();
    const productUrl = link.getAttribute('href');
    const variantPicker = document.querySelector('variant-picker[context="main_product"]');
    if (!variantPicker) return;
    switchToProduct(productUrl, variantPicker.getAttribute('section-id'));
  }, true);

  function persistOnProductNavigation(event) {
    const link = event.target.closest(
      'variant-picker a[href], color-option-redirect a[href*="/products/"], a.product-card__media[href*="/products/"], a.product-title[href*="/products/"]'
    );
    if (!link) return;
    saveCurrentMainSelections();
  }

  function persistOnOptionInteraction(event) {
    const optionControl = event.target?.closest?.('input[data-option-position], label[for], button, [role="radio"]');
    if (!optionControl) return;
    window.setTimeout(saveCurrentMainSelections, 20);
    window.setTimeout(saveCurrentMainSelections, 220);
  }

  document.addEventListener('click', persistOnProductNavigation, true);
  document.addEventListener('pointerdown', persistOnProductNavigation, true);
  document.addEventListener('change', persistOnOptionInteraction, true);
  document.addEventListener('click', persistOnOptionInteraction, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreMainSelections);
  } else {
    restoreMainSelections();
  }

  document.addEventListener('theme:loading:end', restoreMainSelections);
  document.addEventListener('shopify:section:load', restoreMainSelections);
  window.addEventListener('pageshow', restoreMainSelections);
})();
